// Import dependencies
import { html } from 'lit';

/**
 * Retrieves directory fields data and sentence based on the given type.
 *
 * @param {String} type - The type of iterable expression (e.g., 'token').
 * @return {Object} An object containing directory fields data and sentence.
 */
const getLoop = ( type ) => {
	const directoryMap = {
		token: {
			fields: [
				{
					option_code: 'TOKEN',
					type: 'text',
					label: _uo.utility.escHTML( wp.i18n.__( 'Token', 'uncanny-automator' ) ),
					required: true,
					supports_tokens: true,
					only_loopable_tokens: true,
					show_label_in_sentence: false,
					clear_when_adding_token: true
				}
			],
			sentence: _uo.utility.sprintf(
				/* translators: 1. Token name */
				_uo.utility.escHTML( wp.i18n.__( '{{Token:%1$s}}', 'uncanny-automator' ) ),
				'TOKEN'
			),
			dialog_helper: html`
				${ _uo.utility.escHTML( wp.i18n.__( 'Loop through tokens that contain multiple items, such as Woo products, LearnDash courses, BuddyBoss memberships, and more.', 'uncanny-automator' ) ) } <a href="${ _uo.utility.addParametersUTM( 'https://automatorplugin.com/knowledge-base/token-loops/', { medium: 'token_loop_dialog', content: 'learn_more' } ) }" target="_blank">${ _uo.utility.escHTML( wp.i18n.__( 'Learn more', 'uncanny-automator' ) ) } <uo-icon id="external-link"></uo-icon></a>
			`
		}
	};

	return directoryMap[ type ] || {};
}

export default getLoop;
